import { render, staticRenderFns } from "./EndPremiumNengaPage.vue?vue&type=template&id=0d3ee9ca&scoped=true&"
import script from "./EndPremiumNengaPage.vue?vue&type=script&lang=js&"
export * from "./EndPremiumNengaPage.vue?vue&type=script&lang=js&"
import style0 from "./EndPremiumNengaPage.vue?vue&type=style&index=0&id=0d3ee9ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3ee9ca",
  null
  
)

export default component.exports